import URI from 'urijs';
import * as c from 'utils/constants/constants';
import { MiddlewareAPI } from 'redux';
import { openDialog } from 'utils/officeJS/dialogUtils';
import { LsKey, lsSet } from 'utils/localStorageUtils';
import { NO_OFFICE } from 'utils/constants/constants';

const USER_LOGGING_OUT_ACTION = 'loginState/userLoggingOut';

const logOutMiddleWare = (store: MiddlewareAPI) => (next: any) => (action: any) => {
  const result = next(action);
  if (action.type !== USER_LOGGING_OUT_ACTION) return result;
  const redirectUrl = new URI(`?action=${c.LOGOUT_ACTION}`).absoluteTo(window?.location.toString()).toString();
  lsSet(LsKey.A_TOKEN, '');
  const dialogUrl = `${c.logoutAppUrl}${redirectUrl}`;
  NO_OFFICE ? window.location.assign(dialogUrl) : openDialog(dialogUrl, false, false, store.dispatch);
  return result;
};

export default logOutMiddleWare;
